import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import {
  clearProgressBar,
  setProgressBar,
} from 'features/ad/progressBar/progressBarSlice'

const useProgressBar = progress => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setProgressBar(progress))
    return () => {
      dispatch(clearProgressBar())
    }
  }, [dispatch, progress])
}

useProgressBar.propTypes = {
  progress: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      active: PropTypes.bool,
      done: PropTypes.bool,
    })
  ).isRequired,
}

export default useProgressBar
